import { Button, Container, Grid, Typography } from "@mui/material";
import type { SxProps } from "@mui/material";
import { useNavigate } from "react-router";
import ToastMessages from "constants/ToastMessages";
import type { ReactNode } from "react";

const marginTopSx: SxProps = { marginTop: { xs: 4, md: 8 } };

interface ErrorPageProps {
  title?: string;
  subtitle?: string;
  message?: string;
  image?: string;
}

function ErrorPage({ title, subtitle, message, image }: Readonly<ErrorPageProps>): ReactNode {
  const navigate = useNavigate();

  const textContainerSizes = image == null ? { xs: 12 } : { xs: 10, md: 3, xl: 4 };

  return (
    <Container maxWidth={false}>
      <Grid
        container
        columns={{ xs: 4, md: 8, xl: 12 }}
        spacing={3}
        direction="row-reverse"
        sx={{ alignItems: "flex-start", justifyContent: "center" }}>
        {image != null && (
          <Grid size={{ xs: 4, md: 5, xl: 6 }}>
            <img
              style={{ objectFit: "contain", width: "100%" }}
              alt="error illustration"
              src={image}
            />
          </Grid>
        )}
        <Grid container spacing={3} size={textContainerSizes}>
          <Grid size={12}>
            <Typography variant="h1" sx={marginTopSx}>
              {title ?? ":'("}
            </Typography>
            <Typography sx={marginTopSx}>{subtitle ?? ToastMessages.ERROR}</Typography>
          </Grid>
          {message != null && (
            <Grid size={12}>
              <Typography>{message}</Typography>
            </Grid>
          )}
          <Grid sx={marginTopSx} size={12}>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/");
                navigate(0);
              }}>
              Retour à l'accueil
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ErrorPage;
